<template>
<div class="scrolling-box">  

<b-container >
  <div
    class="d-flex justify-content-between"
    style="margin-top: 35px"
  >
    <b-col style="padding: 0.2rem; text-align: center">
      <b-button 
        variant="msstreamblue"
        class="col-7"
        style="padding: 6px"
        @click="newIframe"
      >
        <font-awesome-layers >
          <font-awesome-icon :icon="['fas', 'file-export']" size="lg" transform="shrink-8" />
          <font-awesome-icon :icon="['far', 'circle']" size="lg" />
        </font-awesome-layers>&nbsp;&nbsp;
        {{$ml.get('newel')}}
      </b-button>
      &nbsp;
      <b-button variant="darkblue" @click="openExportLink = !openExportLink">
        <b-icon icon="info-circle-fill" />
      </b-button>
      <b-button variant="mswarning" style="margin-left:5px" @click="getIframes">
        <font-awesome-icon :icon="['fas', 'sync']"></font-awesome-icon>
      </b-button>
    </b-col>
  </div>
</b-container>

  <b-card v-if="openExportLink" no-body border-variant="msstream" bg-variant="msstream" text-variant="light">
    <!--<b-card-header header-bg-variant="msstream" header-text-variant="light" class="text-center">Log In</b-card-header>-->
    <b-card-body>
      <b-row class="justify-content-center text-center">
          <h2 v-html="$ml.get('copyonelink')"></h2>
      </b-row>
      <b-row class="marginaltop justify-content-center text-center">
          <h5 v-html="$ml.get('exportvids')"></h5>
      </b-row>
      <b-row class="justify-content-center text-center">
        <b-col md="8" cols="12">
          <p v-html="$ml.get('exportlink')"></p>
        </b-col>
      </b-row>
    </b-card-body> 
  </b-card>

  <div class="greysearch" style="margin-top:30px; margin-bottom:30px">
    <b-form @submit.prevent="searchIframes()">
      <b-form-group style="margin-bottom: 3px">
        <b-input-group>
          <b-input-group-prepend
            ><b-button
              type="submit"
              class="input-group-text"
              variant="db-sb"
              ><font-awesome-icon
                icon="search"
              ></font-awesome-icon></b-button
          ></b-input-group-prepend>
          <b-form-input 
            v-model="exportSearchBar" 
            @input="startTimeoutSearch">
          </b-form-input>
          <b-input-group-append id="popover-help" style="cursor: pointer"
            ><b-input-group-text>
              <font-awesome-icon
                icon="question-circle"
              ></font-awesome-icon> </b-input-group-text
          ></b-input-group-append>
          <b-popover
            target="popover-help"
            title="Help with searchbar"
            triggers="hover"
            placement="bottomleft"
            content="* Filter on title by default (if no keyword mentioned). Search on video title with keyword: 'vtitle'"
            variant="light"
          ></b-popover>
        </b-input-group>
        <p
          style="
            text-align: center;
            margin-bottom: 0px;
            margin-top: 0.5rem;
            font-size: 90%;
          "
        >
          {{$ml.get('filter')}}: <strong>'{{ exportSearchBar }}'</strong> -> {{$ml.get('result')}}:
          <strong>{{ numberOfEL }}</strong
          >/{{ totalNumberOfEL }} {{$ml.get('exportl')}}
        </p>
      </b-form-group>
    </b-form>
  </div>

<!--  
  <b-row class="justify-content-center marginaltop">
    <b-col lg="6" cols="10">
    <b-form @submit.prevent="searchIframes()">
      <b-form-group style="margin-bottom: 5px;">
        <b-input-group>
          <b-input-group-prepend><b-button type="submit" class="input-group-text"><font-awesome-icon icon="search"></font-awesome-icon></b-button></b-input-group-prepend>
          <b-form-input v-model="exportSearchBar" @input="startTimeoutSearch"></b-form-input>
        </b-input-group>
      </b-form-group>
    </b-form>
    </b-col>
  </b-row>
-->

  <b-row v-if="isGetInProgress" class="justify-content-center marginaltop">
    <fade-loader color="#f98e35" style="position: relative; width: 45px; height: 60px; margin: auto; text-align: center"></fade-loader>
  </b-row>

  <b-row class="align-items-center">
    <div v-for="iframe in iframes" v-bind:key="iframe.uuid" class="col-xl-6 col-lg-12">
      <b-card no-body border-variant="msstream" class="marginalsm">
        <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
          <h5 style="margin:0px" class="pointerEltSB" v-if="!iframe._isUpdating" @click="nameUpdating(iframe)">
            {{iframe.name}}&nbsp; 
            <small>
              <font-awesome-icon class="pointerEltSB" icon="pencil-alt" />
            </small>
          </h5>
          <div v-if="iframe._isUpdating">
          <b-form @submit.prevent="updateName(iframe)">
            <b-input-group prepend="Name: " >
              <b-input type="text" v-model="iframe._name"></b-input> 
              <b-input-group-append>
                <b-button variant="emptyBB" style="background-color:white !important" type="submit">
                  <font-awesome-icon class="pointerEltSB" style="color:#14BF98" :icon="['fas', 'check']" />
                </b-button>
                <b-button variant="emptyBBx" style="background-color:white !important" @click="iframe._name=iframe.name;iframe._isUpdating=false;iframes=iframes.splice(0, iframes.length)">
                  <font-awesome-icon class="pointerEltSB" style="color:red" :icon="['fas', 'times']" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
          </div>
        </b-card-header>
        <b-card-body>
          <b-row class="justify-content-around">
            <b-col class="mypanel col-lg-6 col-md-12">
              <h5 style="text-align:center; padding-bottom:5px; border-bottom: 1px solid #2a5d77">
                <font-awesome-layers style="margin-right:15px; vertical-align:middle">
                  <font-awesome-icon :icon="['fas', 'file-export']" size="lg" transform="shrink-8" />
                  <font-awesome-icon :icon="['far', 'circle']" size="lg" />
                </font-awesome-layers>
                <span style="vertical-align:middle">{{$ml.get('exportl1')}}</span> &nbsp;
                <b-button variant="darkblue" size="sm" @click="selectedIframe = iframe;copyToClipboard(iframe.link); showAndHideModal('confirmClickCopy')">
                  <font-awesome-icon icon="clone" />
                  {{$ml.get('copy')}}
                </b-button>
              </h5>
              <p style="color: grey">
                {{$ml.get('copytc')}}
                <br />
              </p>
              <code :ref="'codeToCopy' + iframe.uuid" style="color:#ba0000">{{iframe.link}}</code>
            </b-col>
            <b-col class="col-lg-5 col-md-12" style="margin: 15px 0px 0px; padding:15px">
              <div v-if="iframe.video">
                <b-row class="justify-content-center">
                  <h5>{{$ml.get('videolinked')}}</h5> 
                </b-row>
                <b-row class="justify-content-center">
                  <p style="word-break: break-word;">{{iframe.videoTitle}}</p>
                </b-row>
              </div>
              <b-row class="justify-content-center" v-if="!iframe.video">
                <h5>{{$ml.get('novideolinked')}}</h5>
              </b-row>

              <div class="marginalsmall">
<!--
                <b-row class="justify-content-center" v-if="iframe.video && previewID !== iframe.uuid">
                  <b-button class="col-md-6 col-8" variant="green" @click="startPreview(iframe)"><font-awesome-icon icon="video"></font-awesome-icon> Preview </b-button>
                </b-row>
                <b-row class="justify-content-around" v-if="iframe.video && previewID === iframe.uuid">
                  <b-button class="col-md-5 col-5" variant="quanteec" @click="stopPreview(iframe)"><font-awesome-icon icon="video"></font-awesome-icon> Close preview </b-button>
                  <b-button class="col-md-5 col-5" variant="mswarning" @click="refreshPreview(iframe)"><font-awesome-icon icon="video"></font-awesome-icon> Refresh preview </b-button>
                </b-row>
-->                
              </div>
              <b-row class="justify-content-center" v-if="iframe.video && previewID === iframe.uuid">

                <div class="resp-container">
                  <iframe id="video-player" class="resp-iframe" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameBorder="0" scrolling="no" :src="previewLink"></iframe>
                </div>
             
              </b-row>
              <b-row class="justify-content-center" v-if="iframe.video && iframe.videoData.length > 0 && previewID !== iframe.uuid">
                <div class="previewContainer" style="z-index:1">
                <b-img class="previewImg"  @click="startPreview(iframe)" style="object-fit:contain; cursor:pointer" :src="iframe.videoData[0].manifest.thumbnail" @error="imgUrlAlt($event, iframe.videoData[0])" fluid/>
              </div>
              </b-row>
            </b-col>
          </b-row>
          
          <b-row class="marginaltop justify-content-around">
              <div class="col-md-6 col-sm-5 col-5" ></div>
              <b-button class="col-md-5 col-sm-5 col-5" variant="mswarning" v-if="iframe.videoData.length>0" @click="selectedIframe = iframe;dissociateVideo()"><font-awesome-icon icon="unlink" /> {{$ml.get('dissociate')}}</b-button>
          </b-row>
          <b-row class="marginaltop justify-content-around">
              <b-button class="col-md-6 col-sm-5 col-5" v-if="$auth.getMyUser().roles.indexOf('manager') > -1" variant="quanteec" @click="selectedIframe = iframe;showModal('confirmDelete')"><font-awesome-icon icon="trash" /> {{$ml.get('deletel')}} </b-button>
              <b-button class="col-md-5 col-sm-5 col-5" variant="msstreamblue" @click="selectedIframe = iframe;videoPage=1;getVideos();showModal('selectVideo')"><font-awesome-icon icon="link" /> {{$ml.get('associate')}}</b-button>
          </b-row>
          
        </b-card-body>
      </b-card>
    </div>
    </b-row>

  <b-pagination align="center" :limit="8" :total-rows="realTotalNumberOfPage" v-model="currentPage" :per-page="1" @input="getIframes()"></b-pagination>

    <!-- MODALS -->
    <b-modal ref="errorPost" hide-footer hide-header>
      <div class="d-block text-center">
        <h5 style="border-bottom:1px solid #2a5d77; padding:10px">{{$ml.get('error')}}</h5>
      </div>
      <p style="line-height:normal">{{$ml.get('errorposttxt')}}</p>
      <b-row class="justify-content-center">
        <b-btn class="col-md-5 col-5" variant="mswarning" @click="hideModal('errorPost')">{{$ml.get('close')}}</b-btn>
      </b-row>
    </b-modal>
    <b-modal ref="errorGet" hide-footer hide-header>
      <div class="d-block text-center">
        <h5 style="border-bottom:1px solid #2a5d77; padding:10px">{{$ml.get('error')}}</h5>
      </div>
      <p style="line-height:normal">{{$ml.get('errorgettxt')}}</p>
      <b-row class="justify-content-center">
        <b-btn class="col-md-5 col-5" variant="mswarning" @click="hideModal('errorGet')">{{$ml.get('close')}}</b-btn>
      </b-row>
    </b-modal>
    <b-modal ref="errorPut" hide-footer hide-header>
      <div class="d-block text-center">
        <h5 style="border-bottom:1px solid #2a5d77; padding:10px">{{$ml.get('error')}}</h5>
      </div>
      <p style="line-height:normal">{{$ml.get('errorputtxt')}}</p>
      <b-row class="justify-content-center">
        <b-btn class="col-md-5 col-5" variant="mswarning" @click="hideModal('errorPut')">{{$ml.get('close')}}</b-btn>
      </b-row>
    </b-modal>
    <b-modal ref="errorDelete" hide-footer hide-header>
      <div class="d-block text-center">
        <h5 style="border-bottom:1px solid #2a5d77; padding:10px">{{$ml.get('error')}}</h5>
      </div>
      <p style="line-height:normal">{{$ml.get('errordeltxt')}}</p>
      <b-row class="justify-content-center">
        <b-btn class="col-md-5 col-5" variant="mswarning" @click="hideModal('errorDelete')">{{$ml.get('close')}}</b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="confirmDelete" hide-footer hide-header>
      <div class="d-block text-center">
        <h5 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="color: red; margin-right:5px" :icon="['fas', 'trash']" />
          {{$ml.get('viddel')}}
        </h5>
      </div>
      <p style="line-height:normal">{{$ml.get('confirmdel')}} <strong><span style="color: #2F90B0">{{selectedIframe.name}}</span></strong>. <br>{{$ml.get('linkrecnot')}}</p>
      <b-row class="justify-content-around">
        <b-btn class="col-5" variant="quanteec" @click="deleteIframe(selectedIframe.uuid);hideModal('confirmDelete')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'trash']" />
          {{$ml.get('delete')}}
        </b-btn>
        <b-btn class="col-5" variant="quanteeclg" @click="hideModal('confirmDelete')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('cancel')}}
        </b-btn>
      </b-row>
    </b-modal>

    <!-- Select Video-->
    <b-modal ref="selectVideo" hide-footer hide-header @hidden="cleanVideos">
      <div class="d-block text-center">
        <h5 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'link']" />
          {{$ml.get('selectel')}} <span style="color: #2F90B0">{{selectedIframe.name}}</span> 
        </h5>
      </div>
      <b-row class="justify-content-center">
        <b-form @submit.prevent="videos = []; getVideos()">
          <b-form-group style="margin: 10px; width:300px">
            <b-input-group size="sm">
              <b-input-group-prepend>
                <b-button variant="db-sb" type="submit" class="input-group-text">
                  <font-awesome-icon icon="search" />
                </b-button>
              </b-input-group-prepend>
              <b-form-input v-model="searchBar"></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-form>
      </b-row>
      <b-row>
        <div v-for="video in videos" v-bind:key="video.uuid" v-bind:class="{
          mycard5: true, 
          clickable: true,
          oldcard: (video.uuid === selectedVideo.uuid || (selectedVideo.uuid === undefined && selectedIframe.video === video.uuid))
          }" class='col-sm-4 col-6'>
          <div @click="selectVideo(video)">
            <h6 style="color: #2a5d77; text-align:center; word-break: break-word;">{{video.title}}</h6>
            <b-row class="justify-content-center">
              <div class="previewContainer" style="z-index:1">
                <b-img class="previewImg"  style="object-fit:contain; cursor:pointer" :src="video.manifest.thumbnail" @error="imgUrlAlt($event, video)" fluid/>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
      <b-pagination style="margin:20px" size="sm" align="center" :limit="10" :total-rows="totalPages" v-model="videoPage" :per-page="1" @input="getVideos()" />

      <b-row class="justify-content-around">
        <b-btn class="col-5" variant="msstreamblue" :disabled="!isVideoSelected" @click="videoIsSelected();hideModal('selectVideo')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'check']" />
          OK
        </b-btn>
        <b-btn class="col-5" variant="quanteeclg" @click="hideModal('selectVideo')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('cancel')}}
        </b-btn>
      </b-row>
  </b-modal>

  <b-modal ref="confirmClickCopy" hide-footer hide-header>
    <div class="d-block text-center">
      <h5 style="border-bottom:1px solid #2a5d77; padding:10px">
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'file-export']" />
          {{$ml.get('videoifcode')}}
      </h5>
    </div>
      <p style="line-height:normal">{{$ml.get('ifcodeel')}} <span style="color: #2F90B0">{{selectedIframe.name}}</span> {{$ml.get('iscopied')}}</p>
  </b-modal>

</div>
</template>

<script>
import FadeLoader from "vue-spinner/src/FadeLoader.vue";
import {BASE_EXPORT, BASE_READER, EMBED_URL} from '@/services/base-url'
import IframeService from '@/services/iframe.service';
import VideoService from "@/services/video.service";
var videoService = new VideoService();
var iframeService = new IframeService();
export default {
  name: 'exportLink',
  components: {
    FadeLoader
  },
  data: function() {
    return {
      clientView: (this.$auth.getMyUser().roles.indexOf('admin') > -1) ? this.$auth.getMyClientView() || this.$auth.getMyUser().client : this.$auth.getMyUser().client,
      iframes: [],
      selectedIframe: {},
      previewID: "",
      previewLink: "",
      searchBar: "",
      videos: [],
      selectedVideo: {},
      isVideoSelected: false,
      videoPage: 1,
      videoPageSize: 12,
      baseurl: BASE_READER,
      totalPages: 1,
      realTotalNumberOfPage: 1,
      currentPage: 1,
      numberPerPage: 6,
      exportSearchBar: "",
      isGetInProgress: false,
      timeoutSearch: null,
      timeoutSearchDuration: 2,
      openExportLink: false,
    }
  },
  mounted: function() {
      this.getIframes();
  },
  methods: {
    nameUpdating(iframe) {
      iframe._isUpdating = true;
      iframe._name = iframe.name;
      this.iframes = this.iframes.splice(0, this.iframes.length);
    },
    imgUrlAlt(event, video) {
      try {
        if (video.type === "live") {
          event.target.src = `/thumbnaillive.jpg`;
        } else if (video.encodingStatus === "encoding") {
          event.target.src = `/thumbnail2.jpg`;
        } else {
          event.target.src = `/thumbnail.jpg`;
        }
      } catch(err) {
        event.target.src = `/thumbnail.jpg`;
      }
      
    },
    videoIsSelected() {
      let data = {
        video: this.selectedVideo.uuid,
        type: this.selectedVideo.type,
        videoTitle: this.selectedVideo.title
      }
      this.updateIframe(this.selectedIframe.uuid, data);
    },
    dissociateVideo() {
      let data = {
        video: "",
        type: "",
        videoTitle: ""
      }
      this.updateIframe(this.selectedIframe.uuid, data);
    },
    selectVideo(video) {
      if (this.selectedVideo !== video) {
        this.selectedVideo = video;
        this.isVideoSelected = true;
      } else {
        this.selectedVideo = {};
        this.isVideoSelected = false;
      }
    },
    cleanVideos() {
      this.videos = [];
      this.selectedVideo = {};
      this.isVideoSelected = false;
      this.videoPage = 1;
      this.searchBar = "";
    },
    getVideos() {
      var filter = {
        client: this.clientView, 
      }
      if (this.searchBar !== "") {
        filter.title = {"$regex": "(?i)^.*" + this.searchBar + ".*"}
      }
      videoService.getVideosPageForClient(this.$auth.token(), 
      {
        filter: filter,
        sort: {
          createdAt: -1
        }, 
        page: this.videoPage, 
        pagesize: this.videoPageSize
      }).then((data) => {
            this.totalPages = Math.ceil(data._size / this.videoPageSize);
            this.videos = data._embedded;
        }).catch((err) => {
            this.showModal('errorGet');
        })
    },
    startTimeoutSearch() {
      try {
        clearTimeout(this.timeoutSearch);
      } catch (e) {}
      if (this.oldSearch !== this.search) {
        this.isGetInProgress = true;
        this.timeoutSearch = setTimeout(this.searchIframes, this.timeoutSearchDuration * 1000);
      } else {
        this.isGetInProgress = false;
      }
      
    },
    searchIframes() {

      this.iframes = [];
      this.currentPage = 1;
      this.getIframes();
    },
    getIframes() {
      try {
        clearTimeout(this.timeoutSearch);
      } catch (e) {}
      let myFilter = {
        filter: {
          "$and":[{client: this.clientView}]
        }, 
        sort: {
          createdDate: -1
        }, 
        pagesize: this.numberPerPage, 
        page: this.currentPage
      }
      if (this.exportSearchBar !== "") {
        let words = this.exportSearchBar.split(' ');
        for(let word in words) {
          myFilter.filter["$or"] = []
          myFilter.filter["$or"].push({name:{"$regex": "(?i)^.*" + words[word] + ".*"}});
          myFilter.filter["$or"].push({videoTitle:{"$regex": "(?i)^.*" + words[word] + ".*"}});

        }
      }
      this.oldSearch = this.exportSearchBar;
      this.isGetInProgress = true;
      this.iframes = [];
      iframeService.getIframes(this.$auth.token(), myFilter)
      .then((data) => {
        this.isGetInProgress = false;
          this.iframes = data._embedded;
          this.realTotalNumberOfPage = Math.ceil(data._size / this.numberPerPage);
          for (let index in this.iframes) {
            let iframe = this.iframes[index];
            iframe.src = this.createIframeUrlForID(iframe.uuid);
            iframe.link = this.createIframeCompleteForID(iframe.uuid);
          }
      }).catch((err) => {
        this.isGetInProgress = false;
          this.showModal('errorGet');
      })
    },
    newIframe() {
      var name = "Export Link " + (this.iframes.length + 1);
        iframeService.postIframe(this.$auth.token(), { name: name, client: this.clientView })
        .then((data) => {
            data.src = this.createIframeUrlForID(data.uuid)
            data.link = this.createIframeCompleteForID(data.uuid)
            data.videoData = [];
            this.iframes.unshift(data);
        }).catch((err) => {
            this.showModal('errorPost');
        })
    },
    updateIframe(iframeID, data) {
      iframeService.putIframe(this.$auth.token(), iframeID, data)
        .then((data) => {
            data.src = this.createIframeUrlForID(data.uuid)
            data.link = this.createIframeCompleteForID(data.uuid)
            this.iframes[this.iframes.findIndex(x => x.uuid === iframeID)] = data;
            this.iframes = this.iframes.splice(0, this.iframes.length);
            if (this.previewID === data.uuid) {
              this.refreshPreview(data);
            }
        }).catch((err) => {
            this.showModal('errorPut');
        })
    },
    deleteIframe(iframeID) {
      iframeService.deleteIframe(this.$auth.token(), iframeID)
        .then((data) => {
            this.iframes.splice(this.iframes.findIndex(x => x.uuid === iframeID), 1);
            if (this.previewID === iframeID) {
              this.stopPreview();
            }
        }).catch((err) => {
            this.showModal('errorDelete');
        })
    },
    updateName(iframe) {
      iframe.name = iframe._name; 
      delete iframe._isUpdating;
      this.updateIframe(iframe.uuid, {name: iframe.name});
    },
    cancelTitle(iframe){
      delete iframe._isUpdating;
      this.iframes = this.iframes.splice(0);
    },

    createIframeUrlForID(iframeID) {
      return EMBED_URL + '/embeded.html?uuid=' + iframeID + '&analyticsID=' + this.clientView + '&exp=1';
    },
    createIframeCompleteForID(iframeID) {
      let result = '<iframe id="video-player" style="width:100%;height:100%" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameBorder="0" scrolling="no" src="';
      let iframeSource = this.createIframeUrlForID(iframeID);

      result += iframeSource;
      result += '"></iframe>';
      return result;
    },
    copyToClipboard(text) {
      this.$copyText(text);
    },
    startPreview(iframe) {
      this.previewID = iframe.uuid; 
      this.previewLink = iframe.src;
    },
    stopPreview() {
      this.previewID = ''; 
      this.previewLink = ''
    },
    refreshPreview(iframe) {
      if (this.previewID === iframe.uuid) {
        this.previewLink = '';
        setTimeout(() => {
          if (this.previewID === iframe.uuid) {
            this.previewLink = iframe.src
          }
        }, 50)
      }
    },

    showModal(modalRef) {
      this.$refs[modalRef].show();
    },
    hideModal(modalRef) {
      this.$refs[modalRef].hide();
    },
   
    showAndHideModal(ref) {
      let self = this;
      self.showModal(ref);
      setTimeout(function() {
        self.hideModal(ref)
      }, 3000);
    },


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.resp-container {
  width: 100%;
  padding-top: 56.25%;
  border: 1px solid;
  border-color: lightgrey;
  border-radius: 5px;
  position: relative;
}
.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.oldcard {
    box-shadow: rgba(#14BF98, 0.17) 2px 4px 14px, rgba(#14BF98, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: #fbfbfb !important;
    border-radius: 5px !important;
    border: 0.15rem solid #14BF98 !important;
//    background-color: rgba(109,236,142,0.517647); //green
    &:hover {
      box-shadow: rgba(#14BF98, 0.3) 4px 8px 20px, rgba(#14BF98, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}


  .marginalsmall {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .colorGreen {
    color: rgb(20, 191, 152);
  }

.previewContainer {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  background-color: black;
}

.previewImg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media (min-width: 768px) {
  .greysearch {
    border: 0.125rem solid;
    border-radius: 10px;
    padding: 10px 10px;
    margin: -10px -10px;
    border-color: #2a5d77;
  }
}

.greysearch {
  margin: 0px 0px;
}

.scrolling-box {
  overflow-y: scroll;
  scroll-behavior: smooth;
  height:calc(100vh - 60px);
  margin:0px;
}

</style>
